const HANDOFF_STORAGE_KEY = 'wuffesDosageCalcHandoff';

const mapSiblingViewSuffix = (suffix, targetKind) => {
  if (!suffix) return targetKind === 'jclb' ? 'jclb' : 'jcsb';
  if (targetKind === 'jclb') return suffix.includes('jcsb') ? suffix.replace(/jcsb/g, 'jclb') : suffix;
  return suffix.includes('jclb') ? suffix.replace(/jclb/g, 'jcsb') : suffix;
};

const buildRedirectUrl = (productBaseUrl, mappedSuffix, weight) => {
  try {
    const u = new URL(productBaseUrl, window.location.origin);
    u.searchParams.set('view', mappedSuffix);
    u.searchParams.set('dc_weight', String(weight));
    u.searchParams.set('dc_step', '3');
    return u.pathname + u.search + u.hash;
  } catch {
    const base = productBaseUrl.split('#')[0];
    const sep = base.includes('?') ? '&' : '?';
    return `${base}${sep}view=${encodeURIComponent(mappedSuffix)}&dc_weight=${encodeURIComponent(String(weight))}&dc_step=3`;
  }
};

const readHandoffOnce = () => {
  const params = new URLSearchParams(window.location.search);
  const weightParam = params.get('dc_weight');
  const stepParam = params.get('dc_step');
  let scrollTo = null;
  let weight = weightParam != null && weightParam !== '' ? parseInt(weightParam, 10) : null;
  const step = stepParam != null && stepParam !== '' ? parseInt(stepParam, 10) : null;

  try {
    const raw = sessionStorage.getItem(HANDOFF_STORAGE_KEY);
    if (raw) {
      const o = JSON.parse(raw);
      if (o && typeof o.ts === 'number' && Date.now() - o.ts < 120000) {
        scrollTo = o.scrollTo ?? null;
        if ((weight == null || isNaN(weight)) && o.weight != null) weight = parseInt(o.weight, 10);
      }
      sessionStorage.removeItem(HANDOFF_STORAGE_KEY);
    }
  } catch {}

  if (weightParam != null || stepParam != null) {
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('dc_weight');
      url.searchParams.delete('dc_step');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch {}
  }

  return {
    weight: weight != null && !isNaN(weight) ? weight : null,
    step: step != null && !isNaN(step) ? step : null,
    scrollTo,
  };
};

const productLineForWeight = (weight) => (weight >= 65 ? 'jclb' : 'jcsb');

const getRecTierIndex = (weight, line) => {
  if (line === 'jcsb') return weight <= 35 ? 0 : 1;
  if (weight <= 100) return 0;
  if (weight <= 120) return 1;
  return 2;
};

const getActiveDcOffer = (root) => {
  const visibleTier = root.querySelector('[data-dc-rec-tier]:not([hidden])');
  return visibleTier?.querySelector('input[type="radio"][data-dc-rec-offer]:checked') ?? null;
};

const clearDcRecError = (root) => {
  const errorEl = root?.querySelector('[data-dc-rec-error]');
  if (!errorEl) return;
  errorEl.textContent = '';
  errorEl.hidden = true;
};

const showDcRecError = (root, message) => {
  const errorEl = root?.querySelector('[data-dc-rec-error]');
  if (!errorEl) return;
  errorEl.textContent = message || 'Error adding product to cart. Please try again.';
  errorEl.hidden = false;
};

const updateDcRecCta = (root) => {
  const input = getActiveDcOffer(root);
  const priceEl = root.querySelector('[data-dc-rec-cta-discounted]');
  const oldEl = root.querySelector('[data-dc-rec-cta-compare]');
  const btn = root.querySelector('[data-dc-rec-submit]');

  if (!input || !priceEl) {
    if (btn) btn.hidden = true;
    return;
  }

  if (btn) btn.hidden = false;
  const disc = input.getAttribute('data-discounted-price') || '';
  const def = input.getAttribute('data-default-price') || '';
  priceEl.textContent = disc;

  if (oldEl) {
    const showOld = !!(def && def !== disc);
    oldEl.hidden = !showOld;
    if (showOld) oldEl.textContent = def;
  }
};

const bindDcRecRadios = (root) => {
  if (root.dataset.dcRecBound === '1') return;
  root.dataset.dcRecBound = '1';
  root.addEventListener('change', ({ target }) => {
    if (target?.matches('input[type="radio"][data-dc-rec-offer]')) {
      clearDcRecError(root);
      updateDcRecCta(root);
    }
  });
};

const initDcRec = (root, weight) => {
  if (!root) return;
  root.removeAttribute('hidden');
  const line = productLineForWeight(weight);
  const tier = getRecTierIndex(weight, line);
  root.querySelectorAll('[data-dc-rec-tier]').forEach((el) => {
    el.hidden = parseInt(el.getAttribute('data-dc-rec-tier'), 10) !== tier;
  });
  bindDcRecRadios(root);
  updateDcRecCta(root);
};

const buildKlaviyoTags = (input) => {
  const productType = input.getAttribute('data-product-type') || '';
  const dogSizeTitle = input.getAttribute('data-dogsize') || '';
  const sellingPlanTitle = input.getAttribute('data-interval-title') || '';
  const sellingPlan = input.getAttribute('data-selling-plan');

  const tagName = dogSizeTitle ? `${productType}-${dogSizeTitle}` : productType;
  let tagValue;
  if (sellingPlan && sellingPlan !== 'otp') {
    tagValue = `${sellingPlanTitle.replace(/ /g, '-')}-sub`;
  } else if (dogSizeTitle) {
    tagValue = `${sellingPlanTitle.replace(/ /g, '-')}-nosub`;
  } else {
    tagValue = `${input.getAttribute('data-quantity') || '1'}-nosub`;
  }

  return { [tagName]: tagValue };
};

const dosageRecCartAdd = async (productData, orderAttributesArr, root) => {
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  let sectionsToRender = cart?.getSectionsToRender?.().map((s) => s.id) ?? [];
  if (productData.sections?.length > 0) sectionsToRender = productData.sections;

  const { sections: _omit, ...productDataWithoutSections } = productData;
  const requestBody = {
    ...productDataWithoutSections,
    attributes: orderAttributesArr || {},
    ...(sectionsToRender.length > 0 && { sections: sectionsToRender }),
  };

  try {
    const response = await fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) throw new Error('Error adding product to cart. Please try again.');

    const data = await response.json();
    if (data.status || data.description || data.errors) {
      throw new Error(data.description || data.message || 'Error adding product to cart');
    }
    if (!data.items?.length) throw new Error('Failed to add item to cart');

    if (data.sections && cart?.renderContents) cart.renderContents(data);
    if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');

    clearDcRecError(root);
    return data;
  } catch (e) {
    console.error(e);
    showDcRecError(root, e.message);
    throw e;
  }
};

const dosageRecPerformAdd = async (root) => {
  const input = getActiveDcOffer(root);
  if (!input) return;
  clearDcRecError(root);

  const variantId = input.getAttribute('data-variant-id');
  const quantity = input.getAttribute('data-quantity') || '1';
  const sellingPlan = input.getAttribute('data-selling-plan') || '';
  if (!variantId) return;

  const klaviyoTagsArr = buildKlaviyoTags(input);
  const { sourceType, sourceId, sourceHandle } = document.body.dataset;

  const productData = {
    items: [
      {
        id: variantId,
        quantity: String(quantity),
        properties: {
          _klaviyo_custom_tag: klaviyoTagsArr,
          _product_type: input.getAttribute('data-product-type') || '',
          _jc_dogsize: input.getAttribute('data-dogsize') || '',
          _source_type: sourceType,
          _source_id: sourceId,
          _source_handle: sourceHandle,
        },
      },
    ],
  };

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (cart?.getSectionsToRender) {
    productData.sections = cart.getSectionsToRender().map((s) => s.id);
  }

  if (sellingPlan && sellingPlan !== 'otp') productData.items[0].selling_plan = sellingPlan;

  try {
    await dosageRecCartAdd(productData, klaviyoTagsArr, root);
  } catch (e) {
    console.error(e);
    showDcRecError(root, e.message || 'Error adding product to cart. Please try again.');
  }
};

const runDosageRecSubmit = (root) => {
  const input = getActiveDcOffer(root);
  if (!input) return;
  clearDcRecError(root);

  const sellingPlan = input.getAttribute('data-selling-plan') || '';
  const isSub = !!(sellingPlan && sellingPlan !== 'otp');
  const subNotice = document.querySelector('subscription-notice');

  let userSubs = [];
  try {
    userSubs = JSON.parse(localStorage.getItem('user-current-subs') || '[]');
  } catch {}

  const sku = subNotice?.dataset.sku ?? '';
  const runAdd = () => dosageRecPerformAdd(root);

  if (!subNotice || !isSub) {
    runAdd();
    return;
  }

  const duplicate = Array.isArray(userSubs) && sku && userSubs.includes(sku);
  if (duplicate) {
    window.wuffesDosageRecAfterSubNotice = runAdd;
    window.wuffesDosageRecForceSubscription = true;
    subNotice.open();
    return;
  }

  window.wuffesDosageRecPrepareAddToCart = runAdd;
  window.wuffesDosageRecForceSubscription = true;
  subNotice.open();
};

const scrollToHandoffTarget = (scrollTo, fallbackEl) => {
  const el = scrollTo ? document.getElementById(scrollTo) : null;
  (el || fallbackEl)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const calculateDosage = (weight) => {
  if (weight > 35 && weight < 65) return { maintenance: 2, booster: 4 };
  if (weight > 100 && weight <= 120) return { maintenance: 1.5, booster: 3 };
  if (weight > 120) return { maintenance: 2, booster: 4 };
  return { maintenance: 1, booster: 2 };
};

const updatePluralization = (unitTextElement, amount) => {
  if (!unitTextElement) return;
  for (const node of unitTextElement.childNodes) {
    if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('Soft Chew')) {
      node.textContent = node.textContent.replace(/Soft Chew[s]*/, amount > 1 ? 'Soft Chews' : 'Soft Chew');
      break;
    }
  }
};

const updateIcons = (iconContainer, amount) => {
  if (!iconContainer) return;
  const onePointFiveIcon = iconContainer.querySelector('img.one-point-five-chews-icon');
  const originalIcon = iconContainer.querySelector('img:not(.one-point-five-chews-icon)');
  if (!originalIcon && !onePointFiveIcon) return;

  iconContainer.innerHTML = '';

  if (amount === 1.5 && onePointFiveIcon) {
    const clone = onePointFiveIcon.cloneNode(true);
    clone.style.removeProperty('display');
    clone.classList.remove('hidden');
    iconContainer.appendChild(clone);
    return;
  }

  const source = originalIcon || onePointFiveIcon;
  for (let i = 0; i < Math.floor(amount); i++) {
    const clone = source.cloneNode(true);
    clone.style.removeProperty('display');
    clone.classList.remove('hidden');
    iconContainer.appendChild(clone);
  }
};

const updateDosageCard = (amountElement, dosage) => {
  if (!amountElement) return;
  amountElement.textContent = dosage;
  const card = amountElement.closest('.dosage-calculator__card');
  if (!card) return;
  updatePluralization(card.querySelector('.dosage-calculator__amount, .dosage-amount'), dosage);
  updateIcons(card.querySelector('.dosage-calculator__icon-group, .dosage-icon'), dosage);
};

const sharedHandoff = readHandoffOnce();
let handoffConsumed = false;

class DosageCalculator extends HTMLElement {
  #resizeHandler = null;

  connectedCallback() {
    let handoff = null;
    if (sharedHandoff?.weight != null && sharedHandoff.step === 3 && !handoffConsumed) {
      handoff = sharedHandoff;
      handoffConsumed = true;
    }
    this.#init(handoff);
  }

  disconnectedCallback() {
    if (this.#resizeHandler) {
      window.removeEventListener('resize', this.#resizeHandler);
    }
  }

  #init(handoff) {
    if (this.dataset.dcInitialized) {
      if (this.#resizeHandler) {
        window.addEventListener('resize', this.#resizeHandler);
      }
      return;
    }
    this.dataset.dcInitialized = '1';

    const weightSlider = this.querySelector('.dosage-calculator__weight-slider, .weight-slider');
    const weightSliderContainer = this.querySelector(
      '.dosage-calculator__weight-slider-container, .weight-slider-container'
    );
    const weightSliderProgress = this.querySelector(
      '.dosage-calculator__weight-slider-progress, .weight-slider-progress'
    );
    const currentWeightDisplay = this.querySelector('.dosage-calculator__weight-display, .weight-display');
    const currentWeightText = this.querySelector('[data-dc-weight-value]');
    const calculateBtn = this.querySelector('.dosage-calculator__calculate-button');
    const restartBtn = this.querySelector('.dosage-calculator__restart-button');
    const state1 = this.querySelector('[data-dc-state="input"]');
    const state2 = this.querySelector('[data-dc-state="loading"]');
    const state3 = this.querySelector('[data-dc-state="results"]');
    const maintenanceAmount = this.querySelector('[data-dc-maintenance-amount]');
    const boosterAmount = this.querySelector('[data-dc-booster-amount]');
    const dcRecRoot = this.querySelector('[data-dc-rec]');
    const templateKind = dcRecRoot?.dataset.dcTemplateKind ?? 'jcsb';

    if (!weightSlider || !weightSliderContainer || !weightSliderProgress || !currentWeightDisplay || !currentWeightText)
      return;

    const getThumbWidthPx = (slider) => {
      const cssVar = getComputedStyle(slider).getPropertyValue('--thumb-w').trim();
      const rootPx = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      if (cssVar.includes('rem')) return parseFloat(cssVar) * rootPx;
      if (cssVar.includes('px')) return parseFloat(cssVar);
      return 4.9 * rootPx;
    };

    const updateSliderProgress = () => {
      const min = parseFloat(weightSlider.min);
      const max = parseFloat(weightSlider.max);
      const value = parseFloat(weightSlider.value);
      const t = (value - min) / (max - min);
      const thumbW = getThumbWidthPx(weightSlider);
      const thumbLeftPx = t * (weightSlider.getBoundingClientRect().width - thumbW);

      weightSliderProgress.style.width = `${thumbLeftPx}px`;
      currentWeightText.textContent = value;
      currentWeightDisplay.style.left = `${thumbLeftPx + thumbW / 2}px`;
    };

    const applyHandoffStep3 = (weight) => {
      const dosage = calculateDosage(weight);
      updateDosageCard(maintenanceAmount, dosage.maintenance);
      updateDosageCard(boosterAmount, dosage.booster);
      state1.style.display = 'none';
      state2.style.display = 'none';
      state3.style.display = 'block';
      initDcRec(dcRecRoot, weight);
      requestAnimationFrame(() => scrollToHandoffTarget(handoff.scrollTo, this));
    };

    if (handoff?.weight != null && handoff.step === 3) {
      weightSlider.value = String(handoff.weight);
      updateSliderProgress();
      applyHandoffStep3(handoff.weight);
    } else {
      updateSliderProgress();
    }

    this.#resizeHandler = updateSliderProgress;
    weightSlider.addEventListener('input', updateSliderProgress);
    window.addEventListener('resize', this.#resizeHandler);

    calculateBtn?.addEventListener('click', () => {
      const weight = parseInt(weightSlider.value, 10);
      const needsJclb = weight >= 65;
      const peerUrl = dcRecRoot?.dataset.dcPeerUrl;

      if (peerUrl) {
        try {
          sessionStorage.setItem(
            HANDOFF_STORAGE_KEY,
            JSON.stringify({
              weight,
              scrollTo: dcRecRoot.dataset.dcScrollTarget || null,
              ts: Date.now(),
            })
          );
        } catch {}

        if (templateKind === 'jcsb' && needsJclb) {
          window.location.assign(
            buildRedirectUrl(peerUrl, mapSiblingViewSuffix(dcRecRoot.dataset.dcSuffixJclb || '', 'jclb'), weight)
          );
          return;
        }
        if (templateKind === 'jclb' && !needsJclb) {
          window.location.assign(
            buildRedirectUrl(peerUrl, mapSiblingViewSuffix(dcRecRoot.dataset.dcSuffixJcsb || '', 'jcsb'), weight)
          );
          return;
        }
      }

      const dosage = calculateDosage(weight);
      state1.style.display = 'none';
      state2.style.display = 'block';

      setTimeout(() => {
        updateDosageCard(maintenanceAmount, dosage.maintenance);
        updateDosageCard(boosterAmount, dosage.booster);
        state2.style.display = 'none';
        state3.style.display = 'block';
        initDcRec(dcRecRoot, weight);
      }, 2000);
    });

    restartBtn?.addEventListener('click', () => {
      state1.style.display = 'block';
      state2.style.display = 'none';
      state3.style.display = 'none';

      const defaultWeight = weightSlider.getAttribute('data-default') || weightSlider.getAttribute('value') || 25;
      weightSlider.value = defaultWeight;
      updateSliderProgress();
      currentWeightText.textContent = defaultWeight;

      if (dcRecRoot) {
        dcRecRoot.setAttribute('hidden', '');
        delete dcRecRoot.dataset.dcRecBound;
      }
    });

    this.querySelector('[data-dc-rec-submit]')?.addEventListener('click', () => runDosageRecSubmit(dcRecRoot));
  }
}

customElements.define('dosage-calculator', DosageCalculator);

/* ==========================================================================
   Feeding Calculator — independent from the Dosage Calculator above.
   Separate custom element, state, picker and recommendation logic, and its own
   subscription-notice globals (window.wuffesFeedingRec*). Reuses only the
   generic, DOM-agnostic helpers (buildKlaviyoTags, updateIcons, updatePluralization).
   ========================================================================== */

const getActiveFeedingOffer = (root) => root?.querySelector('input[type="radio"][data-fc-rec-offer]:checked') ?? null;

const clearFeedingRecError = (root) => {
  const errorEl = root?.querySelector('[data-fc-rec-error]');
  if (!errorEl) return;
  errorEl.textContent = '';
  errorEl.hidden = true;
};

const showFeedingRecError = (root, message) => {
  const errorEl = root?.querySelector('[data-fc-rec-error]');
  if (!errorEl) return;
  errorEl.textContent = message || 'Error adding product to cart. Please try again.';
  errorEl.hidden = false;
};

const updateFeedingRecCta = (root) => {
  const input = getActiveFeedingOffer(root);
  const priceEl = root.querySelector('[data-fc-rec-cta-discounted]');
  const oldEl = root.querySelector('[data-fc-rec-cta-compare]');
  const btn = root.querySelector('[data-fc-rec-submit]');

  if (!input || !priceEl) {
    if (btn) btn.hidden = true;
    return;
  }

  if (btn) btn.hidden = false;
  const disc = input.getAttribute('data-discounted-price') || '';
  const def = input.getAttribute('data-default-price') || '';
  priceEl.textContent = disc;

  if (oldEl) {
    const showOld = !!(def && def !== disc);
    oldEl.hidden = !showOld;
    if (showOld) oldEl.textContent = def;
  }
};

const bindFeedingRecRadios = (root) => {
  if (root.dataset.fcRecBound === '1') return;
  root.dataset.fcRecBound = '1';
  root.addEventListener('change', ({ target }) => {
    if (target?.matches('input[type="radio"][data-fc-rec-offer]')) {
      clearFeedingRecError(root);
      updateFeedingRecCta(root);
    }
  });
};

// Show only the offers whose configured weight range contains `weight` (blank bound = open-ended).
const getVisibleFeedingOffers = (root, weight) => {
  const inputs = [...root.querySelectorAll('input[type="radio"][data-fc-rec-offer]')];
  const rangeKey = (input) => `${input.getAttribute('data-fc-min-weight')}|${input.getAttribute('data-fc-max-weight')}`;

  const matches = inputs.filter((input) => {
    const min = parseFloat(input.getAttribute('data-fc-min-weight'));
    const max = parseFloat(input.getAttribute('data-fc-max-weight'));
    return (Number.isNaN(min) || weight >= min) && (Number.isNaN(max) || weight <= max);
  });

  // Safety net for a dosing feature: if a misconfiguration makes offers from more than one
  // weight range match the same weight, keep only the first matching range so a single
  // chews-per-day is ever shown (never two conflicting amounts).
  const chosenKey = matches.length ? rangeKey(matches[0]) : null;
  const visible = matches.filter((input) => rangeKey(input) === chosenKey);

  inputs.forEach((input) => {
    const wrapper = input.closest('.fc-rec__freq');
    if (wrapper) wrapper.hidden = !visible.includes(input);
  });
  return visible;
};

// Applies the matched offer's result-step content: weight-range heading, dosage copy and
// the image for that range (falling back to the block-level image when it has none).
const applyFeedingResultContent = (host, offer, weight) => {
  if (!host) return;

  const titleEl = host.querySelector('[data-fc-range-title]');
  const rangeLabel = offer?.getAttribute('data-fc-range-label') || '';
  if (titleEl && rangeLabel) titleEl.textContent = rangeLabel;

  const dosageEl = host.querySelector('[data-fc-dosage-text]');
  const dosageLabel = offer?.getAttribute('data-fc-dosage-label') || '';
  if (dosageEl && dosageLabel) dosageEl.textContent = dosageLabel;

  // A single scoop icon is always shown, whatever the daily amount works out to.
  host.querySelector('.one-point-five-chews-icon')?.classList.add('hidden');

  const scoped = [...host.querySelectorAll('[data-fc-rec-image]')];
  if (scoped.length) {
    let matched = null;
    scoped.forEach((img) => {
      const min = parseFloat(img.getAttribute('data-fc-min-weight'));
      const max = parseFloat(img.getAttribute('data-fc-max-weight'));
      const inRange = (Number.isNaN(min) || weight >= min) && (Number.isNaN(max) || weight <= max);
      const show = inRange && !matched;
      if (show) matched = img;
      img.hidden = !show;
    });
    const fallback = host.querySelector('[data-fc-rec-image-fallback]');
    if (fallback) fallback.hidden = !!matched;
  }
};

// Reveals the recommendation, shows only offers matching `weight`, ensures one is selected,
// and returns the matched offer's configured chews-per-day (NaN if none matched / unset).
const initFeedingRec = (root, weight) => {
  if (!root) return NaN;
  root.removeAttribute('hidden');
  const visible = getVisibleFeedingOffers(root, weight);
  if (visible.length && !visible.some((input) => input.checked)) {
    visible[0].checked = true;
  }
  bindFeedingRecRadios(root);
  updateFeedingRecCta(root);
  const active = visible.find((input) => input.checked);
  return active ? parseFloat(active.getAttribute('data-fc-chews')) : NaN;
};

const feedingRecCartAdd = async (productData, orderAttributesArr, root) => {
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  let sectionsToRender = cart?.getSectionsToRender?.().map((s) => s.id) ?? [];
  if (productData.sections?.length > 0) sectionsToRender = productData.sections;

  const { sections: _omit, ...productDataWithoutSections } = productData;
  const requestBody = {
    ...productDataWithoutSections,
    attributes: orderAttributesArr || {},
    ...(sectionsToRender.length > 0 && { sections: sectionsToRender }),
  };

  try {
    const response = await fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) throw new Error('Error adding product to cart. Please try again.');

    const data = await response.json();
    if (data.status || data.description || data.errors) {
      throw new Error(data.description || data.message || 'Error adding product to cart');
    }
    if (!data.items?.length) throw new Error('Failed to add item to cart');

    if (data.sections && cart?.renderContents) cart.renderContents(data);
    if (cart?.classList.contains('is-empty')) cart.classList.remove('is-empty');

    clearFeedingRecError(root);
    return data;
  } catch (e) {
    console.error(e);
    showFeedingRecError(root, e.message);
    throw e;
  }
};

const feedingRecPerformAdd = async (root) => {
  const input = getActiveFeedingOffer(root);
  if (!input) return;
  clearFeedingRecError(root);

  const variantId = input.getAttribute('data-variant-id');
  const quantity = input.getAttribute('data-quantity') || '1';
  const sellingPlan = input.getAttribute('data-selling-plan') || '';
  if (!variantId) return;

  const klaviyoTagsArr = buildKlaviyoTags(input);
  const { sourceType, sourceId, sourceHandle } = document.body.dataset;

  const productData = {
    items: [
      {
        id: variantId,
        quantity: String(quantity),
        properties: {
          _klaviyo_custom_tag: klaviyoTagsArr,
          _product_type: input.getAttribute('data-product-type') || '',
          _jc_dogsize: input.getAttribute('data-dogsize') || '',
          _source_type: sourceType,
          _source_id: sourceId,
          _source_handle: sourceHandle,
        },
      },
    ],
  };

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (cart?.getSectionsToRender) {
    productData.sections = cart.getSectionsToRender().map((s) => s.id);
  }

  if (sellingPlan && sellingPlan !== 'otp') productData.items[0].selling_plan = sellingPlan;

  try {
    await feedingRecCartAdd(productData, klaviyoTagsArr, root);
  } catch (e) {
    console.error(e);
    showFeedingRecError(root, e.message || 'Error adding product to cart. Please try again.');
  }
};

const runFeedingRecSubmit = (root) => {
  const input = getActiveFeedingOffer(root);
  if (!input) return;
  clearFeedingRecError(root);

  const sellingPlan = input.getAttribute('data-selling-plan') || '';
  const isSub = !!(sellingPlan && sellingPlan !== 'otp');
  const subNotice = document.querySelector('subscription-notice');

  let userSubs = [];
  try {
    userSubs = JSON.parse(localStorage.getItem('user-current-subs') || '[]');
  } catch {}

  const sku = subNotice?.dataset.sku ?? '';
  const runAdd = () => feedingRecPerformAdd(root);

  if (!subNotice || !isSub) {
    runAdd();
    return;
  }

  const duplicate = Array.isArray(userSubs) && sku && userSubs.includes(sku);
  if (duplicate) {
    window.wuffesFeedingRecAfterSubNotice = runAdd;
    window.wuffesFeedingRecForceSubscription = true;
    subNotice.open();
    return;
  }

  window.wuffesFeedingRecPrepareAddToCart = runAdd;
  window.wuffesFeedingRecForceSubscription = true;
  subNotice.open();
};

const calculateFeedingAmount = (weight) => {
  if (weight > 35 && weight < 65) return 2;
  if (weight > 100 && weight <= 120) return 1.5;
  if (weight > 120) return 2;
  return 1;
};

const updateFeedingAmountCard = (amountElement, amount) => {
  if (!amountElement) return;
  amountElement.textContent = amount;
  const card = amountElement.closest('.feeding-calculator__amount');
  if (!card) return;
  updatePluralization(card.querySelector('.feeding-calculator__amount-text'), amount);
  updateIcons(card.querySelector('.feeding-calculator__amount-icons'), amount);
};

const FEEDING_HANDOFF_STORAGE_KEY = 'wuffesFeedingCalcHandoff';
// Broadcast on document.body when the calculator resolves a weight to an offer.
const FEEDING_RESULT_EVENT = 'feedingCalculatorResult';

// Breed-size PDP the selected weight belongs to: jctb <=35, jcsb 36-65, jclb 66+.
const feedingLineForWeight = (weight) => {
  if (weight >= 66) return 'jclb';
  if (weight >= 36) return 'jcsb';
  return 'jctb';
};

const buildFeedingRedirectUrl = (productUrl, weight) => {
  try {
    const u = new URL(productUrl, window.location.origin);
    u.searchParams.set('fc_weight', String(weight));
    u.searchParams.set('fc_step', '3');
    return u.pathname + u.search + u.hash;
  } catch {
    const base = productUrl.split('#')[0];
    const sep = base.includes('?') ? '&' : '?';
    return `${base}${sep}fc_weight=${encodeURIComponent(String(weight))}&fc_step=3`;
  }
};

const readFeedingHandoffOnce = () => {
  const params = new URLSearchParams(window.location.search);
  const weightParam = params.get('fc_weight');
  const stepParam = params.get('fc_step');
  let scrollTo = null;
  let weight = weightParam != null && weightParam !== '' ? parseInt(weightParam, 10) : null;
  const step = stepParam != null && stepParam !== '' ? parseInt(stepParam, 10) : null;

  try {
    const raw = sessionStorage.getItem(FEEDING_HANDOFF_STORAGE_KEY);
    if (raw) {
      const o = JSON.parse(raw);
      if (o && typeof o.ts === 'number' && Date.now() - o.ts < 120000) {
        scrollTo = o.scrollTo ?? null;
        if ((weight == null || Number.isNaN(weight)) && o.weight != null) weight = parseInt(o.weight, 10);
      }
      sessionStorage.removeItem(FEEDING_HANDOFF_STORAGE_KEY);
    }
  } catch {}

  if (weightParam != null || stepParam != null) {
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('fc_weight');
      url.searchParams.delete('fc_step');
      window.history.replaceState({}, '', url.pathname + url.search + url.hash);
    } catch {}
  }

  return {
    weight: weight != null && !Number.isNaN(weight) ? weight : null,
    step: step != null && !Number.isNaN(step) ? step : null,
    scrollTo,
  };
};

const sharedFeedingHandoff = readFeedingHandoffOnce();
let feedingHandoffConsumed = false;

class FeedingCalculator extends HTMLElement {
  #resizeHandler = null;

  connectedCallback() {
    let handoff = null;
    if (sharedFeedingHandoff?.weight != null && sharedFeedingHandoff.step === 3 && !feedingHandoffConsumed) {
      handoff = sharedFeedingHandoff;
      feedingHandoffConsumed = true;
    }
    this.#init(handoff);
  }

  disconnectedCallback() {
    if (this.#resizeHandler) {
      window.removeEventListener('resize', this.#resizeHandler);
    }
  }

  #init(handoff) {
    if (this.dataset.fcInitialized) {
      if (this.#resizeHandler) window.addEventListener('resize', this.#resizeHandler);
      return;
    }
    this.dataset.fcInitialized = '1';

    const slider = this.querySelector('.feeding-calculator__slider');
    const sliderContainer = this.querySelector('.feeding-calculator__slider-container');
    const sliderProgress = this.querySelector('.feeding-calculator__slider-progress');
    const dogs = this.querySelectorAll('.feeding-calculator__dog');
    const weightInput = this.querySelector('[data-fc-weight-value]');
    const calculateBtn = this.querySelector('.feeding-calculator__calculate-button');
    const restartBtn = this.querySelector('.feeding-calculator__restart-button');
    const stateInput = this.querySelector('[data-fc-state="input"]');
    const stateLoading = this.querySelector('[data-fc-state="loading"]');
    const stateResults = this.querySelector('[data-fc-state="results"]');
    const amountEl = this.querySelector('[data-fc-amount]');
    const recRoot = this.querySelector('[data-fc-rec]');

    if (!slider || !sliderContainer || !sliderProgress || !weightInput) return;

    const getThumbWidthPx = (el) => {
      const cssVar = getComputedStyle(el).getPropertyValue('--fc-thumb-w').trim();
      const rootPx = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      if (cssVar.includes('rem')) return parseFloat(cssVar) * rootPx;
      if (cssVar.includes('px')) return parseFloat(cssVar);
      return 4.3 * rootPx;
    };

    const updateSliderProgress = (syncWeightInput = true) => {
      const min = parseFloat(slider.min);
      const max = parseFloat(slider.max);
      const value = parseFloat(slider.value);
      const t = max === min ? 0 : (value - min) / (max - min);
      const thumbW = getThumbWidthPx(slider);
      const sliderRect = slider.getBoundingClientRect();
      const thumbLeftPx = t * (sliderRect.width - thumbW);

      sliderProgress.style.width = `${thumbLeftPx + thumbW / 2}px`;
      if (syncWeightInput) weightInput.value = value;

      // Each dog lights up to full opacity once the slider thumb (circle) reaches its centre.
      const thumbCenterX = sliderRect.left + thumbLeftPx + thumbW / 2;
      dogs.forEach((dog) => {
        const dogRect = dog.getBoundingClientRect();
        const reached = dogRect.left + dogRect.width / 2 <= thumbCenterX;
        dog.classList.toggle('feeding-calculator__dog--active', reached);
      });
    };

    const clampWeightToRange = (num) => {
      const min = parseFloat(slider.min);
      const max = parseFloat(slider.max);
      return Math.min(max, Math.max(min, num));
    };

    updateSliderProgress();

    this.#resizeHandler = debounce(() => updateSliderProgress(), 150);
    slider.addEventListener('input', () => updateSliderProgress());
    window.addEventListener('resize', this.#resizeHandler);

    // Typing a weight moves the slider circle live; the field is left as-typed until blur/enter.
    weightInput.addEventListener('input', () => {
      const raw = weightInput.value.trim();
      if (raw === '') return;
      const num = parseInt(raw, 10);
      if (Number.isNaN(num)) return;
      slider.value = String(clampWeightToRange(num));
      updateSliderProgress(false);
    });

    // On commit (blur/enter), normalise the field to the clamped slider value.
    weightInput.addEventListener('change', () => {
      const num = parseInt(weightInput.value, 10);
      const fallback = slider.getAttribute('data-default') || slider.value;
      slider.value = String(Number.isNaN(num) ? fallback : clampWeightToRange(num));
      updateSliderProgress();
    });

    const showResults = (weight) => {
      stateInput.classList.add('hidden');
      stateLoading.classList.add('hidden');
      stateResults.classList.remove('hidden');
      // The matched offer's weight range provides the chews-per-day; fall back to the
      // weight formula only if no offer range matches (e.g. a misconfigured page).
      const chews = initFeedingRec(recRoot, weight);
      updateFeedingAmountCard(amountEl, Number.isNaN(chews) ? calculateFeedingAmount(weight) : chews);

      const offer = recRoot ? getActiveFeedingOffer(recRoot) : null;
      applyFeedingResultContent(this, offer, weight);

      // Lets variant-scoped sections elsewhere on the page follow the calculated weight.
      const variantId = offer?.getAttribute('data-variant-id') || '';
      if (variantId) {
        document.body.dispatchEvent(
          new CustomEvent(FEEDING_RESULT_EVENT, {
            detail: { variantId, weight, dogsize: offer.getAttribute('data-dogsize') || '' },
          })
        );
      }
    };

    calculateBtn?.addEventListener('click', () => {
      const weight = parseInt(slider.value, 10);

      // If the weight belongs to a different breed-size PDP, hand off and redirect there.
      const targetKind = feedingLineForWeight(weight);
      const currentKind = this.dataset.fcKind || '';
      const targetUrl = {
        jctb: this.dataset.fcUrlJctb || '',
        jcsb: this.dataset.fcUrlJcsb || '',
        jclb: this.dataset.fcUrlJclb || '',
      }[targetKind];

      if (currentKind && targetKind !== currentKind && targetUrl) {
        try {
          sessionStorage.setItem(
            FEEDING_HANDOFF_STORAGE_KEY,
            JSON.stringify({
              weight,
              scrollTo: this.dataset.fcScrollTarget || null,
              ts: Date.now(),
            })
          );
        } catch {}
        window.location.assign(buildFeedingRedirectUrl(targetUrl, weight));
        return;
      }

      stateInput.classList.add('hidden');
      stateLoading.classList.remove('hidden');

      // Brief loading state mirrors the Dosage Calculator UX before showing results.
      setTimeout(() => showResults(weight), 2000);
    });

    restartBtn?.addEventListener('click', () => {
      stateInput.classList.remove('hidden');
      stateLoading.classList.add('hidden');
      stateResults.classList.add('hidden');

      const defaultWeight = slider.getAttribute('data-default') || slider.getAttribute('value') || 25;
      slider.value = defaultWeight;
      updateSliderProgress();

      if (recRoot) {
        recRoot.setAttribute('hidden', '');
        delete recRoot.dataset.fcRecBound;
      }
    });

    this.querySelector('[data-fc-rec-submit]')?.addEventListener('click', () => runFeedingRecSubmit(recRoot));

    // Arrived via a cross-PDP redirect: apply the handed-off weight and jump straight to results.
    if (handoff?.weight != null && handoff.step === 3) {
      slider.value = String(clampWeightToRange(handoff.weight));
      updateSliderProgress();
      showResults(parseInt(slider.value, 10));
      // rAF: scroll only after the results state has painted so the target has its final height.
      requestAnimationFrame(() => {
        const target = handoff.scrollTo ? document.getElementById(handoff.scrollTo) : null;
        (target || this).scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }
}

if (!customElements.get('feeding-calculator')) {
  customElements.define('feeding-calculator', FeedingCalculator);
}
